<mat-form-field>
	<mat-label>{{ label }}</mat-label>
	<mat-select [formControl]="formControl" (selectionChange)="emitChange()">
		@for (year of years(); track year) {
			<mat-option [value]="year">
				{{ year }}
			</mat-option>
		}
	</mat-select>
</mat-form-field>
